import * as coreApi from "api/Core";
import GenericListSelection, { IGenericListSelectionProps } from 'components/GenericListSelection';
import * as React from 'react';
import { useTranslation } from "react-i18next";

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const GroupListSelection: React.FC<IGenericListSelectionProps> = (props) => {
    const { t } = useTranslation();
    return (
        <GenericListSelection
            title={t("Views.Group.Components.GroupListSelection.HeaderTitle")}
            showThumbnail={true}
            multi={props.multi}
            onGetData={coreApi.getGroupSelection}
            onSelect={props.onSelect}
        />
    );
};

export default GroupListSelection;